module.exports = __webpack_public_path__ + "static/img/SketchPng5883cb1a44551c00cf1362750d869b642cb21d5fa5121b457abf41606c08a17a.52741156.png";